<template>
  <div class="slug">
    <Widgets v-if="page?.widgets" :widgets="page?.widgets" />
  </div>
</template>

<script lang="ts" setup>
import { useBreadcrumbs } from '@/state/breadcrumbs'
import { useAnimationDisabled } from '@/state/pixelAnimationData'
import { flatten, emptyToUndefined } from '@/utils'

const { locale } = useI18n()
const route = useRoute()
const slug = flatten(route.params.slug)
const category = emptyToUndefined(flatten(route.params.category))

const { data: page, error } = await useAsyncData('pageSlug', () =>
  useApi().publicPagesSimplePagesRetrieve(slug)
)

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

const pixelAnimationDisabled = useAnimationDisabled()
pixelAnimationDisabled.value = Boolean(page.value?.pixels_disabled)

const { setBreadcrumbs } = useBreadcrumbs()

if (page.value)
  setBreadcrumbs([
    {
      text: page.value?.title,
      to: { name: 'slug', params: { slug: page.value?.slug } }
    }
  ])

const expectedCategory = emptyToUndefined(
  // @ts-ignore
  page.value?.[`category_${locale.value}`] as string | null | undefined
)

if (expectedCategory !== category) {
  const redirectRoute: {
    name: string
    params: { category: string; slug: string } | { slug: string }
  } = expectedCategory
    ? { name: 'category-slug', params: { category: expectedCategory, slug } }
    : { name: 'slug', params: { slug } }

  await navigateTo(useLocalePath()(redirectRoute), { redirectCode: 301 })
}

const setI18nParams = useSetI18nParams()
setI18nParams({
  en: {
    slug: page.value?.slug_en,
    ...(expectedCategory && { category: expectedCategory })
  },
  pl: {
    slug: page.value?.slug_pl,
    ...(expectedCategory && { category: expectedCategory })
  }
})

const meta = usePrepareSEOMeta(page)

useHead({
  title: page.value?.title,
  meta
})
</script>
